import { Dialog } from "vant";

export default {
  toExternalLogin() {
    Dialog.confirm({
      title: "提示",
      message: "无权限，请先登录",
      confirmButtonText: "去登录"
    })
      .then(_ => {
        console.log("去登录回调");
        window.jump({type: 0});
      })
      .catch(() => {
        // on cancel
      });
  },
  showLoading() {
    window.vm.$loading.show();
    setTimeout(() => {
      // if(window.vm.$loading.status()) {
      //   window.vm.$toast('网络错误')
      // }
      window.vm.$loading.hide();
    }, 10000);
  }
};
